import Vue from "vue"
/*************************************************自定义组件*********************************************************/
import PageGroup from "../tool/PageGroup.vue"
import Table from "../tool/Table.vue"
import Preview from "../tool/Preview.vue"
import UploadTable from "../tool/UploadTable.vue"
import UploadInput from "../tool/UploadFile.vue"
import Editor from "../tool/Editor.vue"
import EditorInput from "../tool/EditorInput.vue"
import SortTransfer from "../tool/SortTransfer.vue"
import TableButton from "../tool/TableButton.vue"
import FormInput from "../tool/FormInput.vue"
import Uploads from "../tool/UploadFiles.vue"
import AMapLoader from '@amap/amap-jsapi-loader';//高德地图
import MapPoint from "../tool/MapPoint.vue"
import MapLine from "../tool/MapLine.vue"
import MapPolygon from "../tool/MapPolygon.vue"
import Camera from "../tool/Camera.vue"
Vue.component('my-page', PageGroup)
Vue.component('my-table', Table)
Vue.component('my-preview', Preview)
Vue.component('my-upload-table', UploadTable)
Vue.component('my-upload', UploadInput)
Vue.component('my-uploads', Uploads)
Vue.component('my-edit', Editor)
Vue.component('my-edit-input', EditorInput)
Vue.component('my-sort-transfer', SortTransfer)
Vue.component('my-table-button', TableButton)
Vue.component('my-input', FormInput)
Vue.component('map-point', MapPoint)
Vue.component('map-line', MapLine)
Vue.component('map-polygon', MapPolygon)
Vue.component('camera', Camera)
Vue.use(PageGroup);
Vue.use(Table);
Vue.use(Preview);
Vue.use(UploadTable);
Vue.use(UploadInput);
Vue.use(SortTransfer);
Vue.use(EditorInput);
Vue.use(TableButton);
Vue.use(FormInput);
Vue.use(Editor);
Vue.use(Uploads);
Vue.use(MapPoint);
Vue.use(MapLine);
Vue.use(MapPolygon);
Vue.use(Camera);
// window._AMapSecurityConfig = {
//     securityJsCode: "「你申请的安全密钥」",
// };
AMapLoader.load({
    key: "943780ca2d3919268da6eec8ec517a0c", // 申请好的Web端开发者Key，首次调用 load 时必填
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.CircleMarker','AMap.MarkerCluster'], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
})




